import {
    GET_MESSAGES_REQUEST,
    GET_MESSAGES_SUCCESS,
    GET_MESSAGES_FAILED
} from '../../actions/message/get-messages'

import {
    ADD_MESSAGE_SUCCESS
} from '../../actions/message/add-message'

import {
    READ_MESSAGE_SUCCESS
} from '../../actions/message/read-message'

const initialState = {
    messages: [],
    requesting: false,
    error: null,
    total: 0
}

export const messages = (state = initialState, action) => {
    switch (action.type) {
        case GET_MESSAGES_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                messages: [],
                error: null
            })
        case GET_MESSAGES_SUCCESS:
            return Object.assign({}, state, {
                messages: Object.values(action.payload.data.payload.orderedMessages),
                requesting: false,
                error: action.error,
                total: action.payload.data.payload.total
            })
        case GET_MESSAGES_FAILED:
            return Object.assign({}, state, {
                messages: [],
                requesting: false,
                error: null
            })
        case READ_MESSAGE_SUCCESS:        
            return Object.assign({}, state, {
                messages: state.messages.map((thread) => {
                    return Object.assign({}, thread, {messages: thread.messages.map((message) => {
                        if (-1 !== action.messageIds.indexOf(message.id)) {
                            return Object.assign({}, message, {read: true})
                        }
                        return message
                    })})
                })
            })
        case ADD_MESSAGE_SUCCESS:
            // console.log(state)
            // console.log(action.payload.data.payload)
            return state;
        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/message/messages.js